import React, { FC, useEffect } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { ContentModule } from '@nhl/nhl-react-ui/lib/ContentModule';
import LoadingDisplay from '@nhl/nhl-react-ui/lib/LoadingDisplay';

import { useAwardCategoriesQuery, useFranchiseAwardsQuery } from '../../../redux/ducks/franchiseAwards';
import { useFranchisesQuery } from '../../../redux/ducks/franchises';
import '../../../styles/common/react-table.scss';
import TemplateKeys from '../../../utils/contentModuleTemplateKeys';
import { AwardRecipients, SubNav, NavListSelect, TableLayout } from '../../components';
import { FranchiseTombstone } from '../../pages/franchise/components/franchiseTombstone';

import './styles.scss';

const selectedLinkValue = (navigate, selectedNav) => navigate(`/awards/${selectedNav.value}`);

const createNavigation = (awardCategories, selectedAwardCategory) => {
    const navigate = useNavigate();
    if (awardCategories.length === 0 || !awardCategories.find(({ value }) => value === selectedAwardCategory)) {
        return '';
    }
    return (
        <SubNav>
            <NavListSelect
                label="View"
                selected={awardCategories.find((x) => x.value === selectedAwardCategory) || {}}
                availableOptions={awardCategories}
                parent="awards"
                selectFunction={(e) => {
                    selectedLinkValue(navigate, e);
                }}
                className="full-width"
            />
        </SubNav>
    );
};

const Awards: FC = () => {
    const navigate = useNavigate();
    const params = useParams();
    const selectedAwardCategory = params.view && decodeURI(params.view);

    const { data: franchises = [], isFetching: isFranchisesFetching } = useFranchisesQuery({});
    const franchiseTriCode = window.recordsSettings.franchiseTricode.toLowerCase();
    const selectedFranchiseId = franchises.find((f) => f.teamAbbrev.toLowerCase() === franchiseTriCode)?.id || -1;

    const {
        data: awardCategories = [],
        isSuccess: isAwardSuccess,
        isFetching: isAwardFetching,
    } = useAwardCategoriesQuery(selectedFranchiseId, {
        skip: selectedFranchiseId === -1,
    });

    const trophyCategory = awardCategories.find((a) => a.value === selectedAwardCategory);
    const hookOptions = {
        franchiseId: selectedFranchiseId,
        trophyCategory,
    };
    const { data: franchiseAwards = [], isFetching: isFranchiseFetching } = useFranchiseAwardsQuery(hookOptions);

    const isLoading = isAwardFetching || isFranchiseFetching || isFranchisesFetching;

    useEffect(() => {
        // We will redirect any invalid categories to a valid one
        if (awardCategories.length > 0 && !trophyCategory) {
            navigate(`/awards/${awardCategories[0].value}`);
        }
    }, [awardCategories, trophyCategory, history]);

    const noAwards =
        isAwardSuccess && awardCategories.length === 0 ? (
            <TableLayout>
                <h2>No Awards</h2>
            </TableLayout>
        ) : (
            ''
        );
    const franchiseTrophies = franchiseAwards.trophies
        ? franchiseAwards.trophies.map((item, index) => {
              const { data, trophy } = item;
              return (
                  <TableLayout key={index}>
                      <h3>{trophy.name}</h3>
                      <AwardRecipients
                          recipients={data}
                          slug={trophy.slug}
                          type={franchiseAwards.trophyCategory.trophyRecipientCategory}
                          franchises={franchises}
                          franchiseAwards={true}
                      />
                  </TableLayout>
              );
          })
        : noAwards;

    return (
        <LoadingDisplay isLoading={isLoading}>
            <div className="franchise-awards">
                <ContentModule
                    className="hero-module"
                    baseUrl={window.recordsSettings.franchiseScopedRestUrl}
                    templateKey={TemplateKeys.AWARDS_INDEX}
                    sequence={1}
                    isPublic
                />

                <FranchiseTombstone />
                {createNavigation(awardCategories, selectedAwardCategory)}
                {franchiseTrophies}
            </div>
        </LoadingDisplay>
    );
};

export default Awards;
